import api from 'apis/config/api-service';

interface Unit {
  id?: string | number;
  [key: string]: any;
}

interface UnitParams {
  [key: string]: any;
}

export default {
  getUnits: (params?: UnitParams) => api.get('unit', { ...params }),
  getUnitById: (id: string | number) => api.get(`unit/${id}`),
  addOrUpdateUnit: (unit: Unit) => (unit.id ? api.patch(`unit/${unit.id}`, unit) : api.post('unit', unit)),
};
